import * as bootstrap from 'bootstrap'; // eslint-disable-line no-unused-vars
import { register } from 'swiper/element/bundle';
import "@hotwired/turbo-rails";
import "./controllers/index_store";

register(); // register Swiper custom elements

// [...document.querySelectorAll('[data-bs-toggle="tooltip"]')].forEach((el) => new bootstrap.Tooltip(el));
